import { Component, Input, OnInit } from '@angular/core';
import { RewardsWalletItem, WalletItemType } from '@fgb/core';

@Component({
  selector: 'fgbcl-rewards-wallet-redeemed-list',
  templateUrl: './rewards-wallet-redeemed-list.component.html',
  styleUrls: ['./rewards-wallet-redeemed-list.component.scss'],
})
export class RewardsWalletRedeemedListComponent implements OnInit {
  @Input() onlyRedeemed: boolean = false;
  @Input() take?: number;
  @Input() pageSize = 8;
  @Input() pageNumber = 1;
  @Input() redeemedItems: RewardsWalletItem[];
  @Input() marketplaceWalletUrl = `/rewards/wallet/details/`;
  @Input() auctionWalletUrl = `/rewards/bids/details/`;
  @Input() lottoWalletUrl = `/rewards/wallet/raffledetails/`;
  pageLength: number = 0;

  constructor() {}

  ngOnInit() {}

  getItemDetailUrl(item: RewardsWalletItem): string {
    if (item.ItemType == WalletItemType.Auction) {
      return `${this.auctionWalletUrl}${item.WalletId}`;
    } else if (item.ItemType == WalletItemType.Marketplace) {
      return `${this.marketplaceWalletUrl}${item.WalletId}`;
    } else if (item.ItemType == WalletItemType.Lotto) {
      return `${this.lottoWalletUrl}${item.WalletId}`;
    }
    return '';
  }
}
